
export class DeviceItem {
    constructor(
        public IdCliente: string,
        public Manufacturer: string,
        public Model: string,
        public SerialNumber: string,
        public RegisteredItemName: string,
        public PurchasePrice: string,
        public PurchasedDate: string,
        public DeviceType: string,
        public ExpirationDate: string,
        public RiskTypeCode: string,
        public CaseNumber: string,
        public InteractionNumber: string,
        public DealerCode: string,
        public CompanyCode: string
    ){}
}
